import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "top" }, null, -1)
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "links" }
const _hoisted_4 = {
  href: "https://github.com/humanoidsandvichdispenser/integradle",
  tooltip: "GitHub homepage"
}
const _hoisted_5 = {
  href: "https://sandvich.xyz/tools/integradle/",
  tooltip: "Comments"
}
const _hoisted_6 = {
  key: 1,
  class: "display"
}
const _hoisted_7 = { class: "preview" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "background" }, null, -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notifications = _resolveComponent("notifications")!
  const _component_integradle_title = _resolveComponent("integradle-title")!
  const _component_bootstrap_icon = _resolveComponent("bootstrap-icon")!
  const _component_visualizer = _resolveComponent("visualizer")!
  const _component_grid = _resolveComponent("grid")!
  const _component_keyboard = _resolveComponent("keyboard")!
  const _directive_katex = _resolveDirective("katex")!
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_notifications, { position: "top center" }),
    _withDirectives((_openBlock(), _createElementBlock("div", {
      tabindex: "0",
      onKeyup: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.pushKey && _ctx.pushKey(...args))),
      style: {"outline":"none"}
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_integradle_title)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, [
          _createVNode(_component_bootstrap_icon, { icon: "github" })
        ]),
        _createElementVNode("a", _hoisted_5, [
          _createVNode(_component_bootstrap_icon, { icon: "chat-dots-fill" })
        ]),
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {
                    _ctx.newPuzzle(false);
                    $event.target.blur();
                }),
          tooltip: "New puzzle with 1 term"
        }, [
          _createVNode(_component_bootstrap_icon, { icon: "dice-1-fill" })
        ]),
        _createElementVNode("a", {
          id: "hardmode-icon",
          href: "#",
          onClick: _cache[1] || (_cache[1] = ($event: any) => {
                    _ctx.newPuzzle(true);
                    $event.target.blur();
                }),
          tooltip: "New puzzle with 2 terms ✌️💿"
        }, [
          _createVNode(_component_bootstrap_icon, { icon: "dice-2-fill" })
        ]),
        _createElementVNode("a", {
          id: "darkmode-icon",
          href: "#",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleDarkMode())),
          tooltip: "Toggle light/dark"
        }, [
          (_ctx.theme == 'light')
            ? (_openBlock(), _createBlock(_component_bootstrap_icon, {
                key: 0,
                icon: "sun-fill"
              }))
            : (_openBlock(), _createBlock(_component_bootstrap_icon, {
                key: 1,
                icon: "moon-fill"
              }))
        ])
      ]),
      (_ctx.isFinished)
        ? (_openBlock(), _createBlock(_component_visualizer, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _withDirectives(_createElementVNode("div", _hoisted_7, null, 512), [
              [_directive_katex, _ctx.previewExpression, "display"]
            ])
          ])),
      _hoisted_8,
      _createVNode(_component_grid),
      _createElementVNode("div", {
        class: _normalizeClass({ 'keyboard-container': true, 'kb-open': _ctx.isKBOpen })
      }, [
        _createElementVNode("div", {
          onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", {
            class: "keyboard-header",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isKBOpen = !_ctx.isKBOpen))
          }, [
            (_ctx.isKBOpen)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                  _createVNode(_component_bootstrap_icon, { icon: "x-lg" }),
                  _createTextVNode(" Collapse keyboard ")
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_10, [
                  _createVNode(_component_bootstrap_icon, { icon: "pin-angle-fill" }),
                  _createTextVNode(" Pin keyboard ")
                ]))
          ]),
          _createVNode(_component_keyboard, {
            onPushCharacter: _cache[4] || (_cache[4] = (c) => _ctx.pushCharacter(c)),
            onPopCharacter: _cache[5] || (_cache[5] = (c) => _ctx.popCharacter(c)),
            onSubmit: _ctx.submit
          }, null, 8, ["onSubmit"])
        ])
      ], 2)
    ], 32)), [
      [_directive_focus]
    ])
  ], 64))
}